<template>
  <card-modal>
    <template v-slot:header>
      <span class="title-modal-card" v-text="storeInfo.storeName" />
      <v-spacer></v-spacer>
      <v-btn icon x-large @click="$emit('input', false)">
        <v-icon x-large color="primary" v-text="'mdi-close'" />
      </v-btn>
    </template>
    <template v-slot:body>
      <v-tabs-items v-model="tab" style="width: 100%">
        <v-card-subtitle>
          <div class="modal-title-details">Phone</div>
          <div class="modal-name-details" v-text="storeInfo.phoneNumber" />
          <div
            class="modal-title-details mt-5"
            v-text="$t('general.address')"
          />
          <div class="modal-name-details" v-text="storeInfo.storeAddress" />
          <div
            v-if="storeInfo.description"
            class="modal-title-details mt-5"
            v-text="$t('general.about')"
          />
          <div
            v-if="storeInfo.description"
            class="modal-title-rules"
            v-text="storeInfo.description"
          />
          <div
            class="modal-title-details mt-5"
            v-text="$t('discovery.opening_times')"
          />
          <v-container class="test_orange">
            <v-row
              v-for="(item, index) in storeInfo.openingHours"
              :key="index"
              class="test_green py-1"
              justify="space-between"
              no-gutters
            >
              <v-col class="test_purple">
                <span
                  class="modal-name-details"
                  v-text="$t('days.' + item.dayName)"
                />
              </v-col>
              <span
                v-if="item.isClosed"
                class="modal-name-details active"
                v-text="$t('general.close')"
              />
              <span
                v-else
                class="modal-name-details"
                v-text="
                  $appFormatters.formatTimeEu(item.open) +
                  ' - ' +
                  $appFormatters.formatTimeEu(item.closing)
                "
              />
            </v-row>
          </v-container>
          <div
            v-if="storeInfo.configs.supportDelivery"
            class="modal-title-details mt-5"
            v-text="$t('discovery.deliveryHours')"
          />
          <v-container
            v-if="storeInfo.configs.supportDelivery"
            fluid
            class="test_orange"
          >
            <v-row
              v-for="(item, index) in storeInfo.deliveryHours"
              :key="index"
              class="test_green py-1"
              justify="space-between"
              no-gutters
            >
              <v-col class="test_purple">
                <span
                  class="modal-name-details"
                  v-text="$t('days.' + item.dayName)"
                />
              </v-col>
              <span
                v-if="item.isClosed"
                class="modal-name-details active"
                v-text="$t('general.close')"
              />
              <span
                v-else
                class="modal-name-details"
                v-text="
                  $appFormatters.formatTimeEu(item.open) +
                  ' - ' +
                  $appFormatters.formatTimeEu(item.closing)
                "
              />
            </v-row>
          </v-container>
          <div class="modal-social-icon-details mt-5">
            <v-icon
              v-if="appInfo.facebook"
              class="pr-3"
              @click="openSocialUrl(appInfo.facebook)"
              v-text="'mdi-facebook'"
            />
            <v-icon
              v-if="appInfo.instagram"
              class="pr-3"
              @click="openSocialUrl(appInfo.instagram)"
              v-text="'mdi-instagram'"
            />
            <v-icon
              v-if="appInfo.snapchat"
              class="pr-3"
              @click="openSocialUrl(appInfo.snapchat)"
              v-text="'mdi-snapchat'"
            />
            <v-icon
              v-if="appInfo.youtube"
              class="pr-3"
              @click="openSocialUrl(appInfo.youtube)"
              v-text="'mdi-youtube'"
            />
            <v-icon
              v-if="appInfo.twitter"
              class="pr-3"
              @click="openSocialUrl(appInfo.twitter)"
              v-text="'mdi-twitter'"
            />
            <div v-if="appInfo.tiktok">
              <v-img
                class="pr-3"
                height="20px"
                width="20px"
                style="cursor: pointer"
                :src="tiktok"
                @click="openSocialUrl(appInfo.tiktok)"
              />
            </div>
          </div>
        </v-card-subtitle>
        <div class="pb-5 mt-5">
          <FooterLinkSection />
        </div>
      </v-tabs-items>
    </template>
  </card-modal>
</template>

<script>
import tiktokImage from "@/assets/img/home/tiktok.jpeg";

export default {
  name: "StoreInfoDetail",
  components: {
    FooterLinkSection: () =>
      import("../../home/components/FooterLinkSection.vue"),
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    storeInfo: function () {
      return this.$store.getters.storeInfo;
    },
    appInfo: function () {
      return this.$store.getters.appInfo;
    },
    tiktok: {
      get() {
        return tiktokImage;
      },
    },
  },
  methods: {
    openSocialUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss"></style>
